import React from 'react'
import { Link } from 'react-router-dom'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Drawer from '@mui/material/Drawer'
import Divider from '@mui/material/Divider'
import Tooltip from '@mui/material/Tooltip'
import Avatar from '@mui/material/Avatar'

import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'

import MailOutlineIcon from '@mui/icons-material/MailOutline'

import { useRecordLock } from '../../contexts/RecordLockContext'
import useSuperMid from '../../hooks/useSuperMid'
import useSuperEnd from '../../hooks/useSuperEnd'
import useVR from '../../hooks/useVR'

const NavSide = ({ sideNavOpen, id }) => {
  const { recordLock } = useRecordLock()
  const { postSuperMidEmailDraft } = useSuperMid({ id })
  const { postSuperEndEmailDraft } = useSuperEnd({ id })
  const { postVREmailDraft } = useVR({ id })

  const emailSuperMidPassdown = () => {
    postSuperMidEmailDraft.mutate()
  }
  const emailSuperEndPassdown = () => {
    postSuperEndEmailDraft.mutate()
  }
  const emailVrPassdown = () => {
    postVREmailDraft.mutate()
  }

  return (
    <>
      <Drawer
        variant='permanent'
        sx={{
          width: sideNavOpen ? 250 : 50,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: sideNavOpen ? 250 : 50,
            boxSizing: 'border-box',
          },
          zIndex: 1,
        }}
      >
        <Box sx={{ pt: '70px' }}>
          {recordLock ? (
            <List>
              {sideNavOpen && (
                <ListItem>
                  <Typography variant='h6'>Super Mid Passdowns</Typography>
                </ListItem>
              )}
              <ListItem disablePadding>
                <Tooltip title='Super Mid Wet Passdown' placement='right' arrow>
                  <ListItemButton component={Link} to='/supermidwet'>
                    <Avatar
                      sx={{ width: 24, height: 24, fontSize: 10, mr: 1 }}
                      children={'SMW'}
                    />
                    {sideNavOpen && <ListItemText primary='Mid Wet' />}
                  </ListItemButton>
                </Tooltip>
              </ListItem>
              <ListItem disablePadding>
                <Tooltip title='Super Mid Dry Passdown' placement='right' arrow>
                  <ListItemButton component={Link} to='/supermiddry'>
                    <Avatar
                      sx={{ width: 24, height: 24, fontSize: 10, mr: 1 }}
                      children={'SMD'}
                    />
                    {sideNavOpen && <ListItemText primary='Mid Dry' />}
                  </ListItemButton>
                </Tooltip>
              </ListItem>
              <ListItem disablePadding>
                <Tooltip
                  title='Email Super Mid Passdown'
                  placement='right'
                  arrow
                >
                  <ListItemButton onClick={emailSuperMidPassdown}>
                    <MailOutlineIcon sx={{ mr: 1 }} />
                    {sideNavOpen && <ListItemText primary='Email Super Mid' />}
                  </ListItemButton>
                </Tooltip>
              </ListItem>
              <Divider />
              {sideNavOpen && (
                <ListItem>
                  <Typography variant='h6'>Super End Passdowns</Typography>
                </ListItem>
              )}
              <ListItem disablePadding>
                <Tooltip title='Super End Wet Passdown' placement='right' arrow>
                  <ListItemButton component={Link} to='/superendwet'>
                    <Avatar
                      sx={{ width: 24, height: 24, fontSize: 10, mr: 1 }}
                      children={'SEW'}
                    />
                    {sideNavOpen && <ListItemText primary='End Wet' />}
                  </ListItemButton>
                </Tooltip>
              </ListItem>
              <ListItem disablePadding>
                <Tooltip title='Super End Dry Passdown' placement='right' arrow>
                  <ListItemButton component={Link} to='/superenddry'>
                    <Avatar
                      sx={{ width: 24, height: 24, fontSize: 10, mr: 1 }}
                      children={'SED'}
                    />
                    {sideNavOpen && <ListItemText primary='End Dry' />}
                  </ListItemButton>
                </Tooltip>
              </ListItem>
              <ListItem disablePadding>
                <Tooltip
                  title='Email Super End Passdown'
                  placement='right'
                  arrow
                >
                  <ListItemButton onClick={emailSuperEndPassdown}>
                    <MailOutlineIcon sx={{ mr: 1 }} />
                    {sideNavOpen && <ListItemText primary='Email Super End' />}
                  </ListItemButton>
                </Tooltip>
              </ListItem>
              <Divider />
              {sideNavOpen && (
                <ListItem>
                  <Typography variant='h6'>Vac Relief Passdown</Typography>
                </ListItem>
              )}
              <ListItem disablePadding>
                <Tooltip title='VR Passdown' placement='right' arrow>
                  <ListItemButton component={Link} to='/vr'>
                    <Avatar
                      sx={{ width: 24, height: 24, fontSize: 10, mr: 1 }}
                      children={'VR'}
                    />
                    {sideNavOpen && <ListItemText primary='VR' />}
                  </ListItemButton>
                </Tooltip>
              </ListItem>
              <ListItem disablePadding>
                <Tooltip title='Email VR Passdown' placement='right' arrow>
                  <ListItemButton onClick={emailVrPassdown}>
                    <MailOutlineIcon sx={{ mr: 1 }} />
                    {sideNavOpen && <ListItemText primary='Email VR' />}
                  </ListItemButton>
                </Tooltip>
              </ListItem>
              <Divider />
            </List>
          ) : (
            <>
              {sideNavOpen && (
                <ListItem>
                  <Typography variant='h6'>
                    You are in Edit Mode. Save or Cancel (bottom of screen) to
                    proceed.
                  </Typography>
                </ListItem>
              )}
            </>
          )}
        </Box>
      </Drawer>
    </>
  )
}

export default NavSide
